export interface ChatReactionItem {
  emoji: string
  name: string
}

export const CHAT_QUICK_REACTIONS: readonly ChatReactionItem[] = [
  { emoji: '👍', name: 'Нравится' },
  { emoji: '😢', name: 'Жаль' },
  { emoji: '🔥', name: 'Огонь!' },
  { emoji: '😂', name: 'До слёз' },
  { emoji: '❤️', name: 'Сердечко' },
  { emoji: '😮', name: 'Шок' },
]

export const CHAT_REACTIONS: readonly ChatReactionItem[] = [
  { emoji: '👍', name: 'Нравится' },
  { emoji: '🔥', name: 'Огонь!' },
  { emoji: '😢', name: 'Жаль' },
  { emoji: '😂', name: 'До слёз' },
  { emoji: '❤️', name: 'Сердечко' },
  { emoji: '😐', name: 'Равнодушен' },
  { emoji: '🥳', name: 'Поздравляю' },
  { emoji: '👌', name: 'ОК' },
  { emoji: '🙂', name: 'Улыбаюсь' },
  { emoji: '🤝', name: 'Договорились' },
  { emoji: '💯', name: 'Поддерживаю' },
  { emoji: '💤', name: 'Засыпаю' },
  { emoji: '❌', name: 'Отмена' },
  { emoji: '✅', name: 'Готово' },
  { emoji: '👀', name: 'Глаза' },
  { emoji: '😉', name: 'Подмигиваю' },
  { emoji: '😃', name: 'Смеюсь' },
  { emoji: '😍', name: 'Красота' },
  { emoji: '😮', name: 'Шок' },
  { emoji: '😔', name: 'Грущу' },
  { emoji: '😭', name: 'Плачу' },
  { emoji: '😜', name: 'Дразнюсь' },
  { emoji: '😎', name: 'Круто' },
  { emoji: '😕', name: 'Ну не знаю' },
  { emoji: '😊', name: 'Смущаюсь' },
  { emoji: '🤔', name: 'Сомневаюсь' },
  { emoji: '😡', name: 'Злюсь' },
  { emoji: '😈', name: 'Злорадно' },
  { emoji: '🤒', name: 'Болею' },
  { emoji: '🤦', name: 'Без комментариев' },
  { emoji: '💩', name: 'Фу' },
  { emoji: '💪', name: 'Мощно' },
  { emoji: '👏', name: 'Великолепно' },
  { emoji: '✋', name: 'Дай пять' },
  { emoji: '👎', name: 'Не нравится' },
  { emoji: '🥰', name: 'Обожаю' },
  { emoji: '😘', name: 'Восхищаюсь' },
  { emoji: '🥺', name: 'Умоляю' },
  { emoji: '😌', name: 'Дзен' },
  { emoji: '🙏', name: 'Спасибо' },
  { emoji: '🤟', name: 'Всё круто' },
  { emoji: '🤡', name: 'Клоун' },
  { emoji: '😛', name: 'Язык' },
  { emoji: '🤘', name: 'Рок!' },
  { emoji: '❓', name: 'Вопрос' },
  { emoji: '❗', name: 'Внимание' },
  { emoji: '💡', name: 'Идея' },
  { emoji: '💣', name: 'Бомба' },
]
